import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import foodimage from '../assets/images.jpeg';
import categories from './data/categories.json';
import foodItems from './data/foodItems.json';
// Assuming you have these images in your assets
import vegLogo from '../assets/vegLogo.png';
import nonVegLogo from '../assets/nonVegLogo.png';

function OrderMeal() {
  const [filteredItems, setFilteredItems] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('All');

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Extract category from URL query
    const queryParams = new URLSearchParams(location.search);
    const categoryFromQuery = queryParams.get('category') || 'All';

    setSelectedCategory(categoryFromQuery);

    // Filter items based on query
    if (categoryFromQuery === 'All') {
      setFilteredItems(foodItems);
    } else {
      setFilteredItems(foodItems.filter((item) => item.category === categoryFromQuery));
    }
  }, [location.search]);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);

    // Update URL query using navigate
    const queryParams = new URLSearchParams();
    if (category !== 'All') queryParams.set('category', category);

    navigate(`?${queryParams.toString()}`);
  };

  return (
    <div className="min-h-screen   p-8 bg-gray-100">
      {/* Categories Navigation */}
      <div className="flex space-x-6 pb-6">
        {categories.map((category) => (
          <button
            key={category.id}
            className={`${
              selectedCategory === category.name
                ? 'bg-black text-white'
                : 'bg-gray-200 text-gray-600'
            } rounded-full px-6 py-3 transition-all duration-300 ease-in-out transform hover:scale-105`}
            onClick={() => handleCategoryClick(category.name)}
          >
            {category.name}
          </button>
        ))}
      </div>

      {/* Section Heading */}
      <div className="mt-3">
        <h2 className="text-2xl font-semibold text-gray-800">Our Favourites</h2>
        <p className="text-gray-500 ">We've created the best dishes just for you. Enjoy!</p>
      </div>

      {/* Card Grid */}
      <div className="grid grid-cols-3 gap-y-6 mt-8 gap-9 ">
        {filteredItems.map((item) => (
          <div
            key={item.id}
            className="bg-white p-6 rounded-lg shadow-lg text-center transition-transform duration-300 hover:scale-105 hover:shadow-xl"
            style={{ width: '380px', height: '400px' }} // Increased height to accommodate availability info
          >
            {/* Food Image */}
            <div className="relative w-full h-40 overflow-hidden rounded-lg">
              <img src={foodimage} alt={item.name} className="w-full h-full object-cover" />
              {/* Veg/Non-Veg Logo */}
              <div className="absolute top-2 right-2">
                <img
                  src={item.isVeg ? vegLogo : nonVegLogo}
                  alt={item.isVeg ? 'Veg' : 'Non-Veg'}
                  className="w-4 h-4"
                />
              </div>
            </div>

            {/* Cuisine Type */}
            <p className="text-sm text-green-600 font-bold mt-4">{item.cuisineType}</p>

            {/* Food Name */}
            <h3 className="text-xl font-semibold text-gray-900 mt-2">{item.name}</h3>

            {/* Description */}
            <p className="text-gray-500 text-sm mt-2">{item.description}</p>

            {/* Availability Indicator */}
            <div className="flex items-center justify-center mt-3">
              <div
                className={`w-2.5 h-2.5 rounded-full mr-2 ${
                  item.isAvailable ? 'bg-red-500' : 'bg-green-500'
                }`}
              ></div>
              <span
                className={`text-sm font-semibold ${
                  item.isAvailable ? 'text-red-500' : 'text-green-500'
                }`}
              >
                {item.isAvailable ? 'Not Available' : 'Available'}
              </span>
            </div>

            {/* Button */}
            <div className="">
              <button
                className="bg-cyan-500 text-white text-sm font-semibold rounded-full px-4 py-2 mt-4 hover:text-black w-full"
                disabled={!item.isAvailable} // Disable button if not available
              >
                Order Meal
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default OrderMeal;
